/**
 * 转换数据类型为前端使用的类型
 * @param {*} typeCode
 * @returns
 */
function getType(typeCode) {
  const serviceType = {
    OBJECT_REFER: 'objectRefer',
    REFER: 'objectRefer',
    DATE_PERIOD: 'array',
    ARRAY: 'array',
    FLOAT: 'number',
    DOUBLE: 'number',
    DECIMAL: 'number',
    MONEY: 'number',
    STRING: 'string',
    STRING_L1: 'string',
    STRING_L2: 'string',
    STRING_L3: 'string',
    LONG: 'number',
    TIME: 'string',
    DATETIME: 'string',
    BOOLEAN: 'boolean',
    INTEGER: 'number',
    DATE: 'string',
    OBJECT: 'object',
  }
  return serviceType[typeCode] ?? 'string'
}

/**
 * 根据格式化类型设置默认参数
 * @param {*} item
 * @param {*} strategy
 */
function formatTransform(item, type, format) {
  const precisionComponent = ['PgInputNumber']
  if (precisionComponent.includes(item.componentCode)) {
    item.parameter.precision = item.parameter.precision ?? format
  }
  item.parameter.type = item.parameter.type ?? type
  item.parameter.format = item.parameter.format ?? format
  return item
}

/**
 * 设置列定义和表单定义默认数据类型等
 */
function propsByFormAndTableItem(item, strategy) {
  if (['input'].includes(item.componentCode)) {
    item.componentCode = 'PgInput'
    //兼容以前老的输入框配置图标
    if (item.parameter.prefix && item.parameter.prefix.startsWith('icon-pg')) {
      item.parameter.prefixIcon = `ivu-icon-${item.parameter.prefix}`
      delete item.parameter.prefix
    }
  }
  switch (item.formatCode) {
    case 'NUMBER':
      return formatTransform(item, 'number', parseInt(strategy.POLICY_NUMBER_PRECISION ?? 6))
    case 'CURRENCY':
      return formatTransform(item, 'currency', 2)
    case 'PRICE':
      return formatTransform(item, 'currency', parseInt(strategy.POLICY_PRICE_PRECISION ?? 6))
    case 'PERCENT':
      return formatTransform(item, 'percent', 0)
    case 'PROGRESS':
      return formatTransform(item, 'progress', 0)
    case 'TIME':
      return formatTransform(item, 'date', 'HH:mm:ss')
    case 'DATE':
      return formatTransform(item, 'date', 'yyyy-MM-dd')
    case 'DATETIME':
      return formatTransform(item, 'date', 'yyyy-MM-dd HH:mm:ss')
    default:
      return item
  }
}

/**
 * 自定义校验表单
 */
const customValidateToForm = {
  objectRefer: () => (rule, value, callback) => {
    let validateFlag = true
    let massage = '必填'
    if (value && typeof value === 'object') {
      if (value instanceof Array) {
        if (value.length == 0) {
          validateFlag = false
        }
      } else {
        if (value == null) {
          validateFlag = false
        } else if (!value.code || value.code == '.') {
          validateFlag = false
        }
      }
    } else {
      validateFlag = false
    }
    if (validateFlag) {
      callback?.()
    } else {
      callback?.(new Error(massage))
    }
  },
  equalExpression:
    (validator, { compileSource, compileData, getTemplateData }) =>
    (rule, value, callback) => {
      let msg = validator.message
      if (!msg) msg = '不满足校验条件'
      const propsCompileData = getTemplateData(null, compileSource.value)
      let propsCompile = null
      propsCompile = compileData(validator.parameter, propsCompileData)
      let validateFlag = propsCompile ? propsCompile.equalExpression : true
      if (rule.required && !value && value !== 0 && value !== false) {
        validateFlag = false
      }
      if (validateFlag) {
        if (callback) callback()
      } else {
        if (callback) callback(new Error(msg))
      }
    },
}

/**
 * 创建表单的校验规则
 */
function creatValidatorToForm(item, compile) {
  const validators = item.validators

  if (item.required) {
    item.validators = {
      type: getType(item.typeCode),
      required: true,
      message: '必填',
      trigger: 'change',
    }
    if (item.validators.type === 'objectRefer')
      item.validators.validator = customValidateToForm.objectRefer()
  } else {
    item.validators = null
  }
  if (validators?.length > 0) {
    const customValidate = validators.map((validator) => {
      return {
        type: getType(item.typeCode),
        required: validator.required,
        trigger: 'change',
        validator: customValidateToForm[validator.type]?.(validator, compile),
      }
    })
    item.validators = item.validators ? [item.validators, ...customValidate] : [...customValidate]
  }
  return item
}

/**
 * 自定义校验表格
 */
const customValidateToTable = {
  objectRefer:
    () =>
    ({ cellValue }) => {
      let validateFlag = true
      let massage = '必填'
      if (cellValue && typeof cellValue === 'object') {
        if (cellValue instanceof Array) {
          if (cellValue.length == 0) {
            validateFlag = false
          }
        } else {
          if (cellValue == null) {
            validateFlag = false
          } else if (!cellValue.code || cellValue.code == '.') {
            validateFlag = false
          }
        }
      } else {
        validateFlag = false
      }
      if (validateFlag) {
        return Promise.resolve()
      } else {
        return new Error(massage)
      }
    },
  equalExpression:
    (validator, { compileSource, compileData, getTemplateData }) =>
    ({ rule, cellValue, row }) => {
      let massage = validator.message
      if (!massage) massage = '不满足校验条件'
      const propsCompileData = getTemplateData(null, { row, ...compileSource })
      let propsCompile = null
      propsCompile = compileData(validator.parameter, propsCompileData)
      let validateFlag = propsCompile ? propsCompile.equalExpression : true
      if (rule.required && !cellValue && cellValue !== 0 && cellValue !== false) {
        validateFlag = false
      }
      if (validateFlag) {
        return Promise.resolve()
      } else {
        return new Error(massage)
      }
    },
}
/***
 * 创建表格的校验规则
 */
function creatValidatorToTable(item, compile) {
  let validators = []
  const initValidators = item.validators || []
  if (item.required) {
    validators = [
      {
        type: getType(item.typeCode),
        required: true,
        message: '必填',
        trigger: 'change',
      },
    ]
    if (validators[0].type === 'objectRefer')
      validators[0].validator = customValidateToTable.objectRefer()
  }
  if (initValidators?.length > 0) {
    validators = [
      ...validators,
      ...initValidators.map((validator) => {
        return {
          trigger: 'change',
          validator: customValidateToTable[validator.type]?.(validator, compile),
        }
      }),
    ]
  }

  return validators
}

/**
 * 转换表单配置项结构
 * {
  code: 唯一值,
  property: 字段名,
  name: 表单项名称,
  label: 表单项显示名（无值时不渲染formItem）,
  title: 字段提示文字
  typeCode: 数据类型,
  formatCode: 格式化,
  length: 输入框允许输入最长length,
  componentCode: 渲染组件,
  parameter: 组件props及少量表单项渲染判断使用字段,
  style: 样式,
  defaultValue: 默认值-支持表达式,
  required: 必填,
  validators: 校验,
  width: 宽度,
  height: 高度,
  disabled: 是否允许编辑,为true时强制将parameter中的disabled设置为true,
  visible: 是否可见,
  show: 是否可见表达式,
 }
 * @param {表单定义} items 
 */
export function transformFormItems(items, strategy, formGroup, compile) {
  if (!items?.length) return []
  const resItems = []
  let formGroupItems = null
  for (let item of items) {
    let column = propsByFormAndTableItem(
      {
        code: item.code || item.property,
        property: item.property,
        name: item.name,
        label: item.label,
        title: item.title,
        typeCode: item.type?.code || item.typeCode,
        formatCode: item.format?.code || item.formatCode,
        length: item.length,
        componentCode: item.component?.code ?? item.componentCode ?? 'PgReadText',
        parameter: { ...item.parameter },
        style: item.style,
        defaultValue: item.defaultValue,
        required: item.required,
        validators: item.validators,
        width: item.width,
        height: item.height,
        disabled: item.disabled,
        visible: item.visible ?? true,
        show: item.show,
      },
      strategy
    )
    column = creatValidatorToForm(column, compile)

    if (!formGroup) {
      resItems.push(column)
    } else if (column.componentCode === 'formGroup') {
      column.children = []
      formGroupItems = column
      resItems.push(formGroupItems)
    } else if (!formGroupItems) {
      formGroupItems = {
        name: '生成标题',
        code: `formGroup_${column.code}`,
        visible: true,
        show: null,
        parameter: {},
        componentCode: 'formGroup',
        children: [column],
      }
      resItems.push(formGroupItems)
    } else {
      formGroupItems.children.push(column)
    }
  }
  return resItems
}

/**
 * 转换表格配置项结构
 * {
  code: 唯一值,
  property: 字段名,
  name: 列名,
  label: 显示列名,
  title: '字段提示文字
  typeCode: 数据类型,
  formatCode: 格式化,
  footer: 表尾合计取值key，无值时取total_${property.replace(/#|\./g, '_')}
  length: 输入框允许输入最长length,
  componentCode: 渲染组件,
  parameter: 组件props及少量表格cell渲染判断使用字段,
  style: 样式,
  required: 必填,
  validators: 校验,
  width: 宽度,
  height: 高度,
  align: 对齐方式,
  fixed: 冻结方式,
  total: 支持合计,
  sort: 是否排序,
  order: 排序列名,
  ascOrder: 是否升序,
  filter: 是否支持过滤,
  disabled: 是否允许编辑,为true时强制将parameter中的disabled设置为true,
  visible: 是否可见,
  show: 是否可见表达式,
  batchModify: 是否支持列批量修改
 }
 * @param {列定义} items 
 */
export function transformColumn(items, strategy, compile) {
  if (!items?.length) return []
  const numberTypeArray = ['FLOAT', 'DOUBLE', 'DECIMAL', 'MONEY', 'LONG', 'INTEGER']
  const rules = {}

  const columns = items.map((item) => {
    const column = {
      code: item.code || item.property,
      property: item.property,
      lead: item.lead,
      name: item.name,
      label: item.label,
      title: item.title,
      typeCode: item.type?.code || item.typeCode,
      formatCode: item.format?.code || item.formatCode,
      footer: item.footer,
      length: item.length,
      componentCode: item.component?.code ?? item.componentCode,
      parameter: { ...item.parameter },
      style: item.style,
      required: item.required,
      validators: item.validators,
      width: item.width,
      height: item.height,
      align: item.align,
      fixed: item.fixed,
      total: item.total,
      sort: item.sort,
      order: item.order,
      ascOrder: item.ascOrder,
      filter: item.filter,
      disabled: item.disabled,
      visible: item.visible ?? true,
      show: item.show,
      batchModify: item.batchModify,
    }
    //数字类型时默认靠右对齐
    if (numberTypeArray.includes(column.typeCode) && !column.align) {
      column.align = 'right'
    }

    const filedValide = creatValidatorToTable(column, compile)
    if (filedValide.length > 0) {
      rules[column.property] = filedValide
    }
    return propsByFormAndTableItem(column, strategy)
  })

  // 转换为树形结构
  const _columns = transformToTree(columns)
  // console.log('columns: ', columns)
  // console.log('_columns: ', _columns)

  return {
    columns: _columns,
    rules,
  }
}

/**
 * 将扁平数组转换为树形结构
 * @param {Array} items - 包含lead和code字段的扁平数组
 * @returns {Array} 树形结构数组
 */
export function transformToTree(items) {
  if (!items?.length) return []

  // 创建映射表，便于快速查找节点
  const nodeMap = new Map()
  const result = []

  // 先将所有项放入映射表中
  items.forEach((item) => {
    nodeMap.set(item.code, { ...item, children: [] })
  })

  // 构建树形结构
  items.forEach((item) => {
    const node = nodeMap.get(item.code)
    // 如果lead为空或等于'0'，则为根节点
    if (!item.lead || item.lead == '0') {
      result.push(node)
    } else {
      // 否则是子节点，找到父节点并添加到其children中
      const parent = nodeMap.get(item.lead)
      if (parent) {
        // 如果子行的 visible 为 false 则过滤掉（不显示）
        if (node.visible) parent.children.push(node)
      } else {
        // 如果找不到父节点，也作为根节点处理
        result.push(node)
      }
    }
  })

  // 过滤掉 children.length > 0 且 visible === false 的根节点
  return result.filter((r) => {
    if (!r.visible && (!r.lead || r.lead == '0') && r.children.length > 0) return false
    return true
  })
}
